import { useMemo } from "react";
import type { StripeElementsPaymentElementOptions } from "../../../StripeElements/types";

export const usePaymentElementTerms =
  (): StripeElementsPaymentElementOptions["terms"] =>
    useMemo(
      () => ({
        card: "never",
        googlePay: "never",
        applePay: "never",
      }),
      [],
    );
